; (function () {
    var

        _$wrapper = null,


        //set to true when a popup is open, can't open another
        _popup_open = false,


        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-template-edit');

            if (_$wrapper.length > 0) {

                setupSaveDocument();

                setupShowTags();

            }
        },


        setupSaveDocument = function () {
            $(".lnkSaveTemplate").on('click', async function () {
                var $saveBtn = $(this);
                $('.spinner-save').show();
                $saveBtn.prop('disabled', true);
                var templateID = $('#ID').val();

                // Create a variable to store the content
                var content = await new Promise((resolve, reject) => {
                    TXTextControl.saveDocument(TXTextControl.StreamType.WordprocessingML, function (e) {
                        resolve(e.data);
                    });
                });

                stopInterval();

                var formData = new FormData();
                formData.append('templateID', templateID);
                formData.append('content', content);

                delta.ajax.postFormData(
                    '/template/edit',
                    formData,
                    function (result) {
                        $saveBtn.prop('disabled', false);
                        $('.spinner-save').hide();
                        $('#LastUpdatedUtc').val(result.lastUpdatedUtc);
                        deleteLocalDocument();
                        saveToLocalStorage(false);
                        startInterval(); 
                    }
                );

                return false;
            });
        },

        setupShowTags = function () {
            $(".btnShowTags").on('click',  function () {
                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(
                        '/Template/Tags',
                        function (html) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'Help: Template Editor',
                                content: html,
                                css: 'modal-lg',
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                            });
                        }
                    )
                }
            });
        }


    dummy = function () { };

    $(document).ready(init);

}());







